enum LoginDialogFields {
	USERNAME = 'username',
	PASSWORD = 'password',
}

export default LoginDialogFields;